import React, { useContext, useState, useEffect } from 'react'

import styles from './AdicionalesOtroProd.module.css'
import Subtitle from '../Subtitle'
import GeneralContext from '../../context/GeneralContext'

import * as Globales from '../../utils/globales'
import * as Funciones from '../../utils/funciones'
import * as GeneralActions from "../../store/actions/generalActions";
import DetallePregunta from '../DetallePregunta/DetallePregunta'
import ListaDetallePreguntaReemplazo from '../ListaDetallePreguntaReemplazo'
import DetalleDeclaracionJurada from '../DetalleDeclaracionJurada/DetalleDeclaracionJurada'
import { COD_PREGUNTA_ORIGIN_FONDOS } from '../../utils/constantes'

const AdicionalesOtroProd = ({ state, setState, paginaActual }) => {
    const initialState = {
        preguntas: []
    }

    const [localState, setLocalState] = useState(initialState)

    const { state: generalState, dispatch: generalDispatch } = useContext(GeneralContext)
    let user = generalState.users.filter(user => user.isAuthenticated)[0]
    let prospecto = user.listaProspectos.filter(prospecto => prospecto.isSelected)[0]
    let cotizacion = prospecto.cotizaciones.filter(cotizacion => cotizacion.isSelected || cotizacion.completado)[0]

    const obtenerMostrarDetalle = (pregunta) => {
        if (pregunta.tipoDetalle === 1) {
            return pregunta.respuestaRapida === 1
        } else if (pregunta.tipoDetalle === 2) {
            if (pregunta.respuestaRapida === 1) {
                if (cotizacion.esAPFamiliar
                    && (state.asegurado.estadoCivil.codigo === 1 || state.asegurado.estadoCivil.codigo === 2
                        || state.asegurado.estadoCivil.codigo === 3 || state.asegurado.estadoCivil.codigo === 5)) {
                    return true
                } else {
                    return false
                }
            } else {
                return false
            }
        }
    }

    useEffect(() => {
        const obtenerRespuestaRapida = (pregunta) => {
            if (pregunta.respuestaRapida === null || pregunta.respuestaRapida === undefined || pregunta.respuestaRapida === -1) {
                if (pregunta.tipoDetalle === 1) {
                    let respuesta = state.asegurado.respuestas.filter(respuesta => respuesta.idBancoPregunta === pregunta.idBancoPregunta
                        && (respuesta.respuesta === 1 || respuesta.respuesta === 0))[0]
                    if (respuesta !== undefined && respuesta !== null) {
                        return respuesta.respuesta
                    } else {
                        return -1
                    }
                } else if (pregunta.tipoDetalle === 2) {
                    let respuestaAsegurado = state.asegurado.respuestas.filter(respuesta => respuesta.idBancoPregunta === pregunta.idBancoPregunta
                        && (respuesta.respuesta === 1 || respuesta.respuesta === 0))[0]
                    let respuestaConyuge = state.conyuge !== undefined && state.conyuge !== null
                        && state.conyuge.respuestas !== undefined
                        ? (state.conyuge && state.conyuge.respuestas) && state.conyuge.respuestas.filter(respuesta => respuesta.idBancoPregunta === pregunta.idBancoPregunta
                            && (respuesta.respuesta === 1 || respuesta.respuesta === 0))[0]
                        : null

                    if (respuestaAsegurado !== undefined && respuestaAsegurado !== null) {
                        return respuestaAsegurado.respuesta
                    } else if (respuestaConyuge !== undefined && respuestaConyuge !== null) {
                        return respuestaConyuge.respuesta
                    } else {
                        return -1
                    }
                } else if (pregunta.tipoDetalle === null) {
                    if (cotizacion.flagDeclaJurada) {
                        if (paginaActual === 'asegurado') {
                            let respuesta = state.asegurado.respuestas.filter(respuesta => respuesta.idBancoPregunta === pregunta.idBancoPregunta
                                && (respuesta.respuesta === 1 || respuesta.respuesta === 0))[0]
                            if (respuesta !== undefined && respuesta !== null) {
                                return respuesta.respuesta
                            } else {
                                return -1
                            }
                        } else if (paginaActual === 'contratante') {
                            let respuesta = state.contratante !== null && state.contratante.respuestas !== undefined
                                ? state.contratante.respuestas.filter(respuesta => respuesta.idBancoPregunta === pregunta.idBancoPregunta
                                    && (respuesta.respuesta === 1 || respuesta.respuesta === 0))[0]
                                : null
                            if (respuesta !== undefined && respuesta !== null) {
                                return respuesta.respuesta
                            } else {
                                return -1
                            }
                        }
                    } else {
                        let respuestaEncontrada = false
                        let respuestasAsegurado = state[paginaActual].respuestas.map(respuesta => {
                            if (respuesta.idBancoPregunta === pregunta.idBancoPregunta) {
                                respuesta.respuesta = 0
                                respuestaEncontrada = true
                            }
                            return respuesta
                        })

                        if (!respuestaEncontrada) {
                            if (respuestasAsegurado.length > 0) {
                                respuestasAsegurado.push({
                                    idBancoPregunta: pregunta.idBancoPregunta,
                                    respuesta: 0
                                })
                            } else {
                                respuestasAsegurado = [{
                                    idBancoPregunta: pregunta.idBancoPregunta,
                                    respuesta: 0
                                }]
                            }
                        }
                        setState((state) => {
                            return {
                                ...state,
                                [paginaActual]: {
                                    ...state[paginaActual],
                                    respuestas: respuestasAsegurado
                                }
                            }
                        })
                        return 0
                    }
                }
            } else {
                if (paginaActual === 'contratante') {
                    if (state.contratante.respuestas !== undefined && state.contratante.respuestas !== null) {
                        return pregunta.respuestaRapida
                    } else {
                        return -1
                    }
                } else {
                    return pregunta.respuestaRapida
                }
            }
        }

        const obtenerApFamiliar = () => {
            if (cotizacion.esAPFamiliar && state.asegurado !== undefined
                && (state.asegurado.estadoCivil.codigo === 1 || state.asegurado.estadoCivil.codigo === 2
                    || state.asegurado.estadoCivil.codigo === 3 || state.asegurado.estadoCivil.codigo === 5)) {
                return true
            } else {
                return false
            }
        }

        const cargarPreguntas = () => {
            //Armando Preguntas Iniciales
            let grupoPregunta = null
            if (cotizacion.esDistintoAsegurado) {
                if (paginaActual === 'asegurado') {
                    grupoPregunta = 1
                } else if (paginaActual === 'contratante') {
                    grupoPregunta = 2
                }
            } else {
                grupoPregunta = 0
            }

            let preguntas = []
            const actuPreguntas = cotizacion.preguntas.map((pregunta) => {
                let retorna = false
                let tipoDetalle = null
                Globales.PREGUNTAS_INICIALES_PROD.map(preguntaGlobal => {
                    if (preguntaGlobal.codigo === pregunta.idBancoPregunta
                        && (preguntaGlobal.grupo === grupoPregunta || grupoPregunta === 0)) {
                        retorna = true
                        tipoDetalle = preguntaGlobal.tipoDetalle
                    }
                    return preguntaGlobal
                })
                if (retorna) {
                    //Armando Respuestas
                    if (state.asegurado !== null && state.asegurado !== undefined) {
                        pregunta.tipoDetalle = tipoDetalle
                        pregunta.respuestaRapida = obtenerRespuestaRapida(pregunta)
                        pregunta.mostrarDetalle = obtenerMostrarDetalle(pregunta)
                        pregunta.listaAsegurados = obtenerListaAsegurados(pregunta)
                        pregunta.apFamiliar = obtenerApFamiliar()
                    } else if (state.contratante !== null && state.contratante !== undefined) {
                        pregunta.tipoDetalle = tipoDetalle
                        pregunta.respuestaRapida = obtenerRespuestaRapida(pregunta)
                    }
                    preguntas.push(pregunta)
                }
                return pregunta
            })

            generalDispatch(GeneralActions.updateAseguradoProspecto(actuPreguntas, null))

            if (localState.preguntas.length === 0) {
                setLocalState((localStateAux) => {
                    return {
                        ...localStateAux,
                        preguntas: preguntas
                    }
                })
            }

            setState((state) => {
                return {
                    ...state,
                    preguntas: preguntas
                }
            })
        }

        cargarPreguntas()
    }, [state.asegurado && state.asegurado.respuestas, state.conyuge, state.contratante && state.contratante.respuestas])

    const obtenerListaAsegurados = (pregunta) => {
        let listaAsegurados = []
        if (pregunta.tipoDetalle === 2) {
            if (pregunta.respuestaRapida === 1) {
                if (cotizacion.esAPFamiliar) {
                    if (state.asegurado.estadoCivil.codigo === 1 || state.asegurado.estadoCivil.codigo === 2) {
                        listaAsegurados.push({
                            codigoAsegurado: 1,
                            parentesco: 'Titular',
                            nombre: Funciones.mostrarCamelCase(state.asegurado.nombres + ' ' + state.asegurado.apellidoPaterno + ' '
                                + state.asegurado.apellidoMaterno)
                        })
                        listaAsegurados.push({
                            codigoAsegurado: 2,
                            parentesco: 'Cónyuge',
                            nombre: state.conyuge ? Funciones.mostrarCamelCase(state.conyuge.nombres + ' ' + state.conyuge.apellidoPaterno + ' '
                                + state.conyuge.apellidoMaterno) : ''
                        })
                    } else if (state.asegurado.estadoCivil.codigo === 3 || state.asegurado.estadoCivil.codigo === 5) {
                        listaAsegurados.push({
                            codigoAsegurado: 1,
                            parentesco: 'Titular',
                            nombre: Funciones.mostrarCamelCase(state.asegurado.nombres + ' ' + state.asegurado.apellidoPaterno + ' '
                                + state.asegurado.apellidoMaterno)
                        })
                    }
                }
            }
        }
        return listaAsegurados
    }

    const handleChangeRespuesta = (pregunta, valorRespuesta) => {
        const cambiarRespuestaTipoUno = () => {
            //Campo de Pregunta Local
            let preguntas = localState.preguntas.map(preguntaAux => {
                if (preguntaAux.idBancoPregunta === pregunta.idBancoPregunta) {
                    preguntaAux.respuestaRapida = valorRespuesta
                }
                return preguntaAux
            })
            setLocalState((localState) => {
                return {
                    ...localState,
                    preguntas: preguntas
                }
            })

            //Cambio de Pregunta Asegurado
            let respuestaEncontrada = false
            let respuestasAsegurado = state.asegurado.respuestas.map(respuesta => {
                if (respuesta.idBancoPregunta === pregunta.idBancoPregunta) {
                    respuesta.respuesta = valorRespuesta
                    respuestaEncontrada = true
                }
                return respuesta
            })

            if (!respuestaEncontrada) {
                if (respuestasAsegurado.length > 0) {
                    respuestasAsegurado.push({
                        idBancoPregunta: pregunta.idBancoPregunta,
                        respuesta: valorRespuesta
                    })
                } else {
                    respuestasAsegurado = [{
                        idBancoPregunta: pregunta.idBancoPregunta,
                        respuesta: valorRespuesta
                    }]
                }
            }

            //Otros Seguros
            let otrosSeguros = state.asegurado.otrosSeguros
            if (valorRespuesta === 0) {
                otrosSeguros = []
            }

            setState((state) => {
                return {
                    ...state,
                    asegurado: {
                        ...state.asegurado,
                        respuestas: respuestasAsegurado,
                        otrosSeguros: otrosSeguros
                    }
                }
            })
        }

        const cambiarRespuestaTipoDos = () => {
            //Campo de Pregunta Local
            let preguntas = localState.preguntas.map(preguntaAux => {
                if (preguntaAux.idBancoPregunta === pregunta.idBancoPregunta) {
                    preguntaAux.respuestaRapida = valorRespuesta
                    preguntaAux.mostrarDetalle = obtenerMostrarDetalle(pregunta)
                    preguntaAux.listaAsegurados = obtenerListaAsegurados(pregunta)
                }
                return preguntaAux
            })

            setLocalState((localState) => {
                return {
                    ...localState,
                    preguntas: preguntas
                }
            })

            if (pregunta.mostrarDetalle) {
                if (valorRespuesta === 1) {
                    //Abre Detalle
                    //Combo -Seleccione-
                    //Eliminar Respuesta Asegurado/Conyuge
                    let respuestasAsegurado = null
                    if (state.asegurado !== null && state.asegurado !== undefined) {
                        respuestasAsegurado = state.asegurado.respuestas.filter(respuesta => respuesta.idBancoPregunta !== pregunta.idBancoPregunta)
                    }

                    let respuestasConyuge = null
                    if (state.conyuge !== null && state.conyuge !== undefined) {
                        respuestasConyuge = state.conyuge.respuestas && state.conyuge.respuestas.filter(respuesta => respuesta.idBancoPregunta !== pregunta.idBancoPregunta)
                    }

                    setState((state) => {
                        return {
                            ...state,
                            asegurado: {
                                ...state.asegurado,
                                respuestas: respuestasAsegurado
                            },
                            conyuge: {
                                ...state.conyuge,
                                respuestas: respuestasConyuge
                            }
                        }
                    })
                } else if (valorRespuesta === 0) {
                    //Nunca se dara
                }
            } else {
                //Agregar Respuesta Asegurado/Conyuge
                //Asegurado
                let respuestaEncontrada = false
                let respuestasAsegurado = state.asegurado.respuestas.map(respuesta => {
                    if (respuesta.idBancoPregunta === pregunta.idBancoPregunta) {
                        respuesta.respuesta = valorRespuesta
                        respuestaEncontrada = true
                    }
                    return respuesta
                })

                if (!respuestaEncontrada) {
                    if (respuestasAsegurado.length > 0) {
                        respuestasAsegurado.push({
                            idBancoPregunta: pregunta.idBancoPregunta,
                            respuesta: valorRespuesta
                        })
                    } else {
                        respuestasAsegurado = [{
                            idBancoPregunta: pregunta.idBancoPregunta,
                            respuesta: valorRespuesta
                        }]
                    }
                }

                //Conyuge
                let respuestasConyuge = []
                if (state.conyuge !== null && state.conyuge !== undefined) {
                    let respuestaEncontradaConyuge = false
                    respuestasConyuge = state.conyuge.respuestas && state.conyuge.respuestas.map(respuesta => {
                        if (respuesta.idBancoPregunta === pregunta.idBancoPregunta) {
                            respuesta.respuesta = valorRespuesta
                            respuestaEncontradaConyuge = true
                        }
                        return respuesta
                    })

                    if (!respuestaEncontradaConyuge) {
                        if (respuestasConyuge === undefined) {
                            respuestasConyuge = []
                        }
                        respuestasConyuge.push({
                            idBancoPregunta: pregunta.idBancoPregunta,
                            respuesta: valorRespuesta
                        })
                    }
                }
                setState((state) => {
                    return {
                        ...state,
                        asegurado: {
                            ...state.asegurado,
                            respuestas: respuestasAsegurado
                        },
                        conyuge: {
                            ...state.conyuge,
                            respuestas: respuestasConyuge
                        }
                    }
                })
            }


        }

        const cambiarRespuestaTipoNull = () => {
            //Campo de Pregunta Local
            let preguntas = localState.preguntas.map(preguntaAux => {
                if (preguntaAux.idBancoPregunta === pregunta.idBancoPregunta) {
                    preguntaAux.respuestaRapida = valorRespuesta
                }
                return preguntaAux
            })
            setLocalState((localState) => {
                return {
                    ...localState,
                    preguntas: preguntas
                }
            })

            //Cambio de Pregunta Asegurado
            let respuestaEncontrada = false
            let respuestasAux = []
            if (state[paginaActual].respuestas !== undefined) {
                respuestasAux = state[paginaActual].respuestas.map(respuesta => {
                    if (respuesta.idBancoPregunta === pregunta.idBancoPregunta) {
                        respuesta.respuesta = valorRespuesta
                        respuestaEncontrada = true
                    }
                    return respuesta
                })
            }

            if (!respuestaEncontrada) {
                if (respuestasAux.length > 0) {
                    respuestasAux.push({
                        idBancoPregunta: pregunta.idBancoPregunta,
                        respuesta: valorRespuesta
                    })
                } else {
                    respuestasAux = [{
                        idBancoPregunta: pregunta.idBancoPregunta,
                        respuesta: valorRespuesta
                    }]
                }
            }

            setState((state) => {
                let subRespuestas = valorRespuesta === 0 ? state[paginaActual].subRespuestas.filter(subRespuesta => subRespuesta.idBancoPregunta === COD_PREGUNTA_ORIGIN_FONDOS) : state[paginaActual].subRespuestas;
                return {
                    ...state,
                    [paginaActual]: {
                        ...state[paginaActual],
                        respuestas: respuestasAux,
                        subRespuestas: subRespuestas
                    },
                    detalle1: valorRespuesta === 0 ? {NIT: null} : state.detalle1,
                    detalle2: valorRespuesta === 0 ? [
                        {
                            pais: null,
                            NIT: null
                        }
                    ] : state.detalle2,
                    noTieneNIT: valorRespuesta === 0 ? 0 : state.noTieneNIT,
                    noTieneNITDesc: valorRespuesta === 0 ? null : state.noTieneNITDesc,
                    subPreguntas: valorRespuesta === 0 ? [] : state.subPreguntas
                }
            })
        }

        if (pregunta.tipoDetalle === 1) {
            cambiarRespuestaTipoUno()
        } else if (pregunta.tipoDetalle === 2) {
            cambiarRespuestaTipoDos()
        } else {
            cambiarRespuestaTipoNull()
        }
    }

    //Modo lectura
    let Deshabilitar = (complete) => {
        complete = cotizacion.edicionInhabilitada
        if (complete === true) {
            return true
        } else {
            return false
        }
    }

    return (
        <div className={styles['areadatosprospecto']}>
            <Subtitle sname='Adicional' />
            {localState.preguntas.map((pregunta, index) => {
                return (
                    (pregunta.idBancoPregunta === 14 || pregunta.idBancoPregunta === 52) && !cotizacion.flagDeclaJurada ?
                    null
                    :
                    <div key={index}
                        className={`${styles['adicionalPregunta']} ${index === 0 ? styles['top18'] : null}`}>
                        <div className={styles['grupodelist']}>
                            <div>{index + 1}.</div>
                            &nbsp;&nbsp;
                            <div className={styles['areaPregunta']}> {/*CMUNAYLLA: se agrega este estilo para alinear las preguntas*/}
                                {pregunta.descripcion}
                            </div>
                            <div className={styles['areaoptionon']}>
                                <form>
                                    <div className={styles["optionlight"]}>
                                        <label className={styles['label-radio']}>
                                            <input
                                                type="radio"
                                                name="light"
                                                value="true"
                                                checked={(state.contratante && state.contratante.respuestas === undefined ? false : pregunta.respuestaRapida === 1)
                                                    || pregunta.respuestaRapida === 1
                                                }
                                                selected={(state.contratante && state.contratante.respuestas === undefined ? false : pregunta.respuestaRapida === 1)
                                                    || pregunta.respuestaRapida === 1
                                                }
                                                onChange={(e) => handleChangeRespuesta(pregunta, 1)}
                                                disabled={Deshabilitar() !== true ? false : true}
                                            />
                                            <span className={`span-radio-si-no ${styles['radio-label']}`}>Si</span>
                                        </label>
                                        <label className={styles['label-radio']}>
                                            <input
                                                type="radio"
                                                name="light"
                                                value="false"
                                                checked={(state.contratante && state.contratante.respuestas === undefined ? false : pregunta.respuestaRapida === 0)
                                                    || pregunta.respuestaRapida === 0
                                                }
                                                selected={(state.contratante && state.contratante.respuestas === undefined ? false : pregunta.respuestaRapida === 0)
                                                    || pregunta.respuestaRapida === 0
                                                }
                                                onChange={(e) => handleChangeRespuesta(pregunta, 0)}
                                                disabled={Deshabilitar() !== true ? false : true}
                                            />
                                            <span className={`span-radio-si-no ${styles['radio-label']}`}>No</span>
                                        </label>
                                    </div>
                                </form>
                            </div>
                        </div>
                        {pregunta !== undefined && pregunta.mostrarDetalle && pregunta.respuestaRapida === 1
                            ? <div>
                                <DetallePregunta
                                    state={state}
                                    setState={setState}
                                    tipo={pregunta.tipoDetalle}
                                    pregunta={pregunta} />
                            </div>
                            : null
                        }

                        {pregunta !== undefined && (pregunta.idBancoPregunta === 3 || pregunta.idBancoPregunta === 44) && pregunta.respuestaRapida === 1 ?
                            <ListaDetallePreguntaReemplazo
                                listaSolicitudes={state.listaSolicitudes || []}
                                state={state}
                                setState={setState}
                            />
                            : null
                        }

                        {/* Reglas para Declaración Jurada */}
                        {pregunta !== undefined && (pregunta.idBancoPregunta === 14 || pregunta.idBancoPregunta === 52) && pregunta.respuestaRapida === 1 ?
                            <DetalleDeclaracionJurada
                                state={state}
                                setState={setState}
                                paginaActual={paginaActual}
                            />
                            : null
                        }
                    </div>
                )
            })}
        </div>
    )
}

export default AdicionalesOtroProd